<template>
    <b-button :disabled="(FeatureName != '' &&  Action != '' ? !$store.getters['CheckAction'](parameters.Right, FeatureName, Action): false) && Disabled"
              :variant="Variant"
              :class="[ButtonInsideClass , (Border ? '' : ' border-0')]"
              pill
              v-on="$listeners">
        <span v-html="$t(parameters.Label)" :class="ContentClass"/>
    </b-button>
</template>

<script lang="ts">
import {Component, Prop} from 'vue-property-decorator';
import ButtonLabel from "../ButtonLabel";
import {ButtonActionEnum} from './ButtonLabelSimpleParameters'
import ButtonParameters from "../../IButtonParameters";

@Component({
    i18n: ButtonLabel.MessageLocales()
})
export default class ButtonLabelSimple extends ButtonLabel {
    /** Action du bouton */
    @Prop({default: () => ""})
    public ButtonAction!: string;

    private parameters: ButtonParameters;

    created() {
        this.parameters = ButtonLabel.GetConstructorParametersButton(ButtonActionEnum, this.ButtonAction, this.Right);
        if (this.parameters == undefined && this.parameters != null)
            console.log('Le bouton ButtonLabel' + this.ButtonAction + ' n\'existe pas.')
    }

    constructor() {
        super();
    }
}
</script>

<style scoped>
</style>